import { loadableReady } from '@loadable/component';
import ReactDOM from 'react-dom';

export const replaceHydrateFunction = () => (element, container, callback) => {
  loadableReady(() => {
    ReactDOM.hydrate(element, container, callback);
  });
};
